/**
 * @desc 退件签收
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.transportMaster.returnSigning.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/returnSigning`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
